import { render, staticRenderFns } from "./UserDetailsView.vue?vue&type=template&id=e08b0dc4&scoped=true&"
import script from "./UserDetailsView.vue?vue&type=script&lang=ts&"
export * from "./UserDetailsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08b0dc4",
  null
  
)

export default component.exports